/* cx: full-screen swipe zoom lightbox (ported from the eliotblake build).
   Mobile only — Dawn's product-media-modal is restyled (CSS) into a horizontal
   scroll-snap carousel; this script adds the ‹ ✕ › control bar and opens the
   modal on the image that was tapped. Desktop keeps the native modal. */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }

  function arrow(cls, label, d) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cx-zoom-btn ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function setupZoomControls() {
    if (!isMobile()) return;
    var dialog = document.querySelector('.product-media-modal__dialog');
    if (!dialog || dialog.__cxControls) return;
    var content = dialog.querySelector('.product-media-modal__content');
    var close = dialog.querySelector('.product-media-modal__toggle');
    if (!content || !close) return;
    dialog.__cxControls = true;

    var prev = arrow('cx-zoom-prev', 'Previous image', 'M15 5 L8 12 L15 19');
    var next = arrow('cx-zoom-next', 'Next image', 'M9 5 L16 12 L9 19');
    function step(dir) {
      var w = content.clientWidth || window.innerWidth;
      content.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });

    close.classList.add('cx-zoom-btn', 'cx-zoom-close');
    var bar = document.createElement('div');
    bar.className = 'cx-zoom-controls';
    bar.appendChild(prev);
    bar.appendChild(close);
    bar.appendChild(next);
    dialog.appendChild(bar);
  }

  function init() { setupZoomControls(); }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);

  /* open on the tapped image — re-applied briefly because Dawn's
     showActiveMedia() forces scrollLeft back to 0 right after opening */
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    var tog = e.target.closest && e.target.closest('.product__media-toggle');
    if (!tog) return;
    var mid = tog.getAttribute('data-media-id');
    if (!mid) return;
    var tries = 0;
    var iv = window.setInterval(function () {
      tries++;
      var modal = document.querySelector('product-modal[open]');
      var content = modal && modal.querySelector('.product-media-modal__content');
      var slide = content && content.querySelector('[data-media-id="' + mid + '"]');
      if (slide && content) content.scrollLeft = slide.offsetLeft;
      if (tries > 12) window.clearInterval(iv);
    }, 30);
  }, false);
})();
